import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const QRCodeFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.38 20.1H6.62C4.86 20.1 3.86 19.1 3.86 17.34V6.58C3.86 4.82 4.86 3.82 6.62 3.82H17.38C19.14 3.82 20.14 4.82 20.14 6.58V17.34C20.14 19.1 19.14 20.1 17.38 20.1ZM13.2 10.76H16.14V7.82H13.2V10.76ZM7.86 10.76H10.8V7.82H7.86V10.76ZM13 14.12H14.16V12.96H13V14.12ZM15.32 14.12H16.48V12.96H15.32V14.12ZM7.86 16.1H10.8V13.16H7.86V16.1ZM14.16 15.28H15.32V14.12H14.16V15.28ZM13 16.44H14.16V15.28H13V16.44ZM15.32 16.44H16.48V15.28H15.32V16.44Z" />
    </SvgIcon>
  );
});
